<app-table [data]="_interventions"
           [config]="tableConfig"
           [selectableRows]="false"
           title="{{'admin.tools.details.interventionsPage.table.title' | translate}}"
           [rowExpand]="false"
           [isMaterial]="isMaterial"
           [isLoading]="isLoading"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.tools.details.interventionsPage.table.columns.header.launchDate' | translate}}"
                      sortable="true"
                      field="launchDate">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  outputDateFormat="timestamp"
                                  [placeholder]="'admin.tools.details.interventionsPage.table.columns.filter.placeholder.launchDate' | translate"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.details.interventionsPage.table.columns.header.launchedBy' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.launchedBy' | translate}}"
                      sortable="true"
                      field="launchedBy">
        <ng-template #body
                     let-intervention="rowData">
            <span>{{ intervention.launchedBy.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column
        header="{{'admin.tools.details.interventionsPage.table.columns.header.interventionStart' | translate}}"
        filter="true"
        filterPlaceholder="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.interventionStart' | translate}}"
        sortable="true"
        field="interventionStart">
    </app-table-column>
    <app-table-column
        header="{{'admin.tools.details.interventionsPage.table.columns.header.interventionEnd' | translate}}"
        filter="true"
        filterPlaceholder="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.interventionEnd' | translate}}"
        sortable="true"
        field="interventionEnd">
    </app-table-column>
    <app-table-column
        header="{{'admin.tools.details.interventionsPage.table.columns.header.operationType' | translate}}"
        filter="true"
        filterPlaceholder="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.operationType' | translate}}"
        sortable="true"
        field="operationType">
        <ng-template #body
                     let-intervention="rowData">
            <span>{{ intervention.operationType.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.details.interventionsPage.table.columns.header.responsible' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.responsible' | translate}}"
                      sortable="true"
                      field="responsible">
        <ng-template #body
                     let-intervention="rowData">
            <span>{{ intervention.responsible?.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.details.interventionsPage.table.columns.header.resolved' | translate}}"
                      field="isOperationResolved">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterResolved"
                          displayField="name"
                          valueField="value"
                          emptyText="{{'admin.tools.details.interventionsPage.table.columns.filter.placeholder.resolved' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-intervention="rowData">
            <span>{{intervention.isOperationResolved ? 'Done' : 'Not Done'}}</span>
        </ng-template>
    </app-table-column>
</app-table>
